<template>
  <a-card :bordered="false">
    <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-item ref="sign" label="中奖时间" name="sign">
        {{form.award_time}}
      </a-form-item>
      <a-form-item ref="account" label="二维码终端门店" name="account">
        {{form.store_name}}
      </a-form-item>
      <a-form-item ref="scene_description" label="提交人" name="scene_description">
        {{form.clerk_name}}
      </a-form-item>
      <a-form-item ref="credentials" label="产品图片" name="credentials">
        <a-image v-for="(item,index) in form.product_image" :key="index" :src="oss+item" alt="avatar" style="max-width:100px" class=" m-l-10" />
      </a-form-item>
         <a-form-item ref="credentials" label="销售小票" name="credentials">
        <a-image v-for="(item,index) in form.sales_receipt" :key="index" :src="oss+item" alt="avatar" style="max-width:100px" class=" m-l-10" />
      </a-form-item>
      <a-form-item ref="power" label="GPS定位" name="power">
        {{form.gps}}
      </a-form-item>
      <a-form-item ref="scan_award_permit_status" label="处理方式" name="scan_award_permit_status" v-if="form.scan_award_permit_status!=0">
        <a-radio-group class="mb10" v-model:value="form.scan_award_permit_status" @change="onChange">
          <a-radio :value="2">
            <span class="s_c333   s_lin_h35">通过</span>
          </a-radio>
          <a-radio :value="3">
            <span class="s_c333   s_lin_h35">拒绝</span>
          </a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item ref="award_fail_reason" label="拒绝原因" name="award_fail_reason" v-if="form.scan_award_permit_status == 3&&typeexa!='look'">
        <a-textarea  v-model:value="form.award_fail_reason" style='width:300px' placeholder="请输入拒绝原因" :rows="4" />
      </a-form-item>
       <a-form-item ref="award_fail_reason" label="拒绝原因" name="" v-if="typeexa=='look'&&form.scan_award_permit_status==3">
        {{form.award_fail_reason}}
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 8, offset: 3 }">
        <a-button type="primary" v-has:examineSubmit="onSubmit" :loading="confirmLoading" v-if="typeexa!='look'">保存</a-button>
        <a-button class="m-r-20 m-l-20" @click="close">
          取消
        </a-button>
      </a-form-item>
    </a-form>
  </a-card>
</template>
<script>
import {} from "@ant-design/icons-vue";
import { ref, onMounted, reactive, toRefs, inject } from "vue";
import { message } from "ant-design-vue";
import { iscode } from "@/utils/app";
import config from "@/config";
import {
  getGuideAwardDetail,
  setexaminestore,
  getdealer_scan_awardDetail,
  setexaminedealer
} from "@/api/guide";
const oss = config.oss[process.env.VUE_APP_type];
import store from "@/store";
// 初始化默认筛选项数值
let defForm = {
  award_time: "",
  store_name: "",
  clerk_name: "",
  product_image: [],
  scan_award_permit_status: 0,
  award_fail_reason: "",
  sales_receipt:[],
};
export default {
  components: {},
  props: {
    typename: String,
    id: {
      type: Number || String,
    },
    typeexa: String,
  },
  setup(props, { emit }) {
    //pass
    const form = ref({ ...defForm });
    const state = reactive({
      loading: false,
      info: store.state.user.info,
      confirmLoading: false,
      typeList: [],
      formData: {},
      labelCol: { span: 3 },
      wrapperCol: { span: 10 },
      scan_award_permit_status: "",
      award_fail_reason: "",
      rules: {
        award_fail_reason: [{ required: true, message: "请输入拒绝原因" }],
        scan_award_permit_status: [
          { required: true, message: "请选择处理方式" },
        ],
      },
    });
    const $route = inject("$route");
    const $router = inject("$router");
    const _lodash = inject("_lodash");
    const getMore = async () => {
      const hide = message.loading("正在加载中...", 0);
      var res;
      if (props.typename == "store") {
        res = await getGuideAwardDetail(props.id)
          .then((res) => res.data)
          .catch((error) => error);
      } else {
        res = await getdealer_scan_awardDetail(props.id)
          .then((res) => res.data)
          .catch((error) => error);
      }

      if (iscode(res)) {
        form.value = res.data.user_info;
        form.value.award_time = res.data.activity_info.award_time;
        form.value.scan_award_permit_status = res.data.activity_info.scan_award_permit_status;
        form.value.product_image = res.data.collections.product_image;
        form.value.sales_receipt = res.data.collections.sales_receipt;
        form.value.award_fail_reason = res.data.activity_info.award_fail_reason;
        form.value.gps = res.data.collections.gps;
        console.log(res);
      } else {
        message.error(res.message);
      }
      setTimeout(hide);
    };
    const ruleForm = ref();
    const onSubmit = async () => {
         var res
        if (props.typename == "store") {
            res= await setexaminestore({
        scan_award_id: props.id,
        scan_award_permit_status: form.value.scan_award_permit_status,
        award_fail_reason: form.value.award_fail_reason,
      })
        .then((res) => res.data)
        .catch((error) => error);
        }else{
        res= await setexaminedealer({
        scan_award_id: props.id,
        scan_award_permit_status: form.value.scan_award_permit_status,
        award_fail_reason: form.value.award_fail_reason,
      })
        .then((res) => res.data)
        .catch((error) => error);
        }
      if (iscode(res)) {
        emit("showclose", false);
        message.success(res.message);
      } else {
        message.error(res.message);
      }
    };
    const close = () => {
      emit("showclose", false);
    };
    onMounted(() => {
      getMore();
    });
    return {
      form,
      ...toRefs(state),
      ruleForm,
      oss,
      onSubmit,
      close,
    };
  },
};
</script>
<style>
</style>